// extracted by mini-css-extract-plugin
export default {"Heading":"SidebarHeading-module__Heading--tOKlB"};